import { z } from 'zod';

/**
 * @deprecated Part of the legacy `Business` collection. The unified
 * `Org` collection drops sector classification at the schema layer.
 * See `BusinessSchema` for the full deprecation note.
 */
export const businessSectorSchema = z.enum(['logistics', 'health']);

/** @deprecated See {@link businessSectorSchema}. */
export type BusinessSector = z.infer<typeof businessSectorSchema>;

/** @deprecated See {@link businessSectorSchema}. */
export const businessClassificationSchema = z.object({
  sector: z.array(businessSectorSchema),
});
